"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.wip.title': 'W trakcie realizacji',
    'socialMediaPlan.wip.description': 'Funkcje planowania mediów społecznościowych wkrótce.',
};
